<template>
    <label
        :class="disabled || !options.length ? ['opacity-75'] : []"
        :for="name"
    >
        <p class="font-medium text-sm sm:text-base">
            <slot></slot>
        </p>
        <div class="select-form relative">
            <select
                class="w-full h-8 px-2 bg-white text-sm focus:outline-none focus:border-2 focus:border-light-blue"
                :class="[classes]"
                :disabled="disabled || !options.length"
                :name="name"
                :id="name"
                :value="value"
                @change="$emit('change', $event.target.value)"
            >
                <option
                    value=""
                    selected
                    disabled
                >
                    <span v-if="!options.length">Cargando...</span>
                    <span v-else>-Seleccionar-</span>
                </option>
                <option
                    v-for="option in options"
                    :key="option.id"
                    :value="option.id"
                >{{ option.description }}</option>
            </select>
        </div>
    </label>
</template>

<script>
export default {
    props: ["name", "value", "options", "classes", "disabled"],
};
</script>

<style>
select {
    /* remove default caret */
    -webkit-appearance: none; /* webkit browsers */
    -moz-appearance: none; /* firefox */
    appearance: none; /* modern browsers */
    width: 100%;
}

.select-form:after {
    content: "";
    font-size: 0.8rem;
    pointer-events: none;
    position: absolute;
    right: 0.5rem;
    top: 0.8rem;
    z-index: 1;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 6px 0 6px;
    border-color: #000 transparent transparent transparent;
}
</style>